import React from 'react';

import { Link } from '@rover/kibble/core';

type Props = Omit<React.ComponentProps<typeof Link>, 'href'> & {
  href: string | undefined;
};

/**
 * Renders a Kibble `Link` when `href` is present; otherwise renders its children
 * as plain text. Service-landing cross-links come from `serviceLinks`, which can
 * be empty or missing an entry for the current country (e.g. when the
 * service-links prefetch fails). In those cases we keep the surrounding sentence
 * intact but drop the hyperlink.
 */
const OptionalLink: React.FC<Props> = ({ href, children, ...rest }) =>
  href ? (
    <Link href={href} {...rest}>
      {children}
    </Link>
  ) : (
    children
  );

export default OptionalLink;
